<template>
    <div class="box" @click="close">
        <img :src="imgUrl" @click.stop alt="">
    </div>
</template>

<script>
    export default {
        props:['imgUrl'],
        data(){
            return {
                isShow:false,
            }
        },
        methods:{
            close(){
                this.$emit('close');
            }
        }
    }
</script>

<style lang="less" scoped>
.box{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    img{
        max-height:100%;
        max-width: 100%;
        object-fit: cover;
    }
}
</style>